import React, { useState, useEffect } from "react";
import axios from "axios";
import AsyncSelect from "react-select/async";

export default function UserSelector({ type, onSelectUser }) {
  const [users, setUsers] = useState([]); // Store fetched users
  const [page, setPage] = useState(1); // Track pagination
  const [searchTerm, setSearchTerm] = useState(""); // Track search input
  const [hasMore, setHasMore] = useState(true); // Check if more pages exist

  useEffect(() => {
    const loadInitialUsers = async () => {
      setPage(1); // Reset page on type change
      const users = await fetchUsers("", 1);
      setUsers(users);
    };
    loadInitialUsers();
  }, [type]);

  const fetchUsers = async (search = "", pageNum = 1) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin/users/`,
        {
          params: {
            limit: 20,
            page: pageNum,
            sort_by: "created_at",
            sort_order: "DESC",
            "filters[1][column]": "u.type",
            "filters[1][operator]": "=",
            "filters[1][value]": type,
            "filters[0][column]": "u.email",
            "filters[0][operator]": "LIKE",
            "filters[0][value]": `%${search}%`,
          },
          headers: {
            "access-token": localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.status) {
        const newUsers = response.data.users.map((user) => ({
          value: user.id,
          label: user.email,
        }));

        setHasMore(newUsers.length > 0); // Stop loading if no more data
        return newUsers;
      }
      return [];
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  };

  const loadMoreUsers = async (inputValue, callback) => {
    setSearchTerm(inputValue);
    setPage(1); // Reset pagination on new search
    const users = await fetchUsers(inputValue, 1);
    setUsers(users);
    callback(users);
  };

  const loadMoreOnScroll = async () => {
    if (!hasMore) return; // Stop if no more data

    const nextPage = page + 1;
    setPage(nextPage);
    const newUsers = await fetchUsers(searchTerm, nextPage);

    if (newUsers.length === 0) {
      setHasMore(false); // No more data to load
    } else {
      setUsers((prevUsers) => [...prevUsers, ...newUsers]);
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadMoreUsers}
      defaultOptions={users}
      onChange={(selected) => onSelectUser?.(selected?.value, selected)}
      isSearchable
      placeholder="Search by email..."
      onMenuScrollToBottom={loadMoreOnScroll}
    />
  );
}
